import { isNativeShell } from "./platform";

/** Keep in sync with android/app/build.gradle versionName. */
export const ANDROID_BUILD_LABEL = "Android build 1.0.10";

export function showAndroidBuildStamp(): boolean {
  if (isNativeShell()) {
    return true;
  }
  return typeof navigator !== "undefined" && /Android/i.test(navigator.userAgent);
}
